import React from 'react';
import { Box, Divider, Stack, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useStyles } from './styles';
import { TrainingCardProps } from '../../types';
import { ActionArrowIcon } from '../../../../assets';
import { ACTION_TO_ICON_MAP, LIST_IMAGE_SIZE } from '../../constants';
import { useTheme } from '../../../../theme';
import { useTranslate } from "../../../../translations";

export const TrainingListItem: React.FC<TrainingCardProps> = ({ training }) => {
  const styles = useStyles();
  const theme = useTheme();
  const t = useTranslate();

  return (
    <>
      <Box className={styles.container}>
        <Stack direction="row" justifyContent="flex-start" spacing={1.5} className={styles.headingWithImageContainer}>
          <img className={styles.image} src={training.imageUrl} width={LIST_IMAGE_SIZE} height={LIST_IMAGE_SIZE} alt={training.title} />
          <Box>
            <Typography variant="subtitle2" className={styles.title}>
              {t(training.titleKey, {defaultValue: training.title})}
            </Typography>
            <Typography variant="body2">
              {t(training.descriptionKey, {defaultValue: training.description})}
            </Typography>
          </Box>
        </Stack>
        <Stack divider={<Divider />}>
          {training.actions.map(action => {
            const StartIcon = ACTION_TO_ICON_MAP[action.type];
            return (
              <Link to={`trainings/${training.id}/${action.type}`} key={action.type} className={styles.link}>
                <Button
                  className={styles.button}
                  fullWidth
                  variant="text"
                  classes={{
                    endIcon: styles.endIcon,
                    text: styles.actionText,
                    startIcon: styles.startIcon,
                  }}
                  endIcon={<ActionArrowIcon stroke={theme.palette.grey[300]} />}
                  startIcon={StartIcon && <StartIcon />}>
                  {t(`wiki.trainings-list.${action.type}`, {defaultValue: action.title})}
                </Button>
              </Link>
            );
          })}
        </Stack>
      </Box>
      <Divider />
    </>
  );
};
